import { useState } from "react"
import { Helmet } from "react-helmet-async"
import { useTripDetailsOutletContext } from "./_trip-details-context"
import { CallLogsTable, TCallLogFilters } from "../../../../CallLogs"

export default function TripCallLogsPage() {
	const { trip } = useTripDetailsOutletContext()
	const [params, setParams] = useState<TCallLogFilters>({})
	return (
		<>
			<Helmet>
				<title>Call Logs | Trip</title>
			</Helmet>
			<CallLogsTable
				params={params}
				setParams={setParams}
				subjectType="trips"
				subjectId={trip.id}
				pagination={true}
			/>
		</>
	)
}
